export const PARCEL_MATCH_TOLERANCE_FT = 75;

export const isAddressPointCompatibleWithParcel = (
    geometryEngine,
    parcelGeometry,
    pointGeometry,
    toleranceFt = PARCEL_MATCH_TOLERANCE_FT
) => {
    if (!geometryEngine || !parcelGeometry || !pointGeometry) return true;

    try {
        if (
            geometryEngine.contains(parcelGeometry, pointGeometry) ||
            geometryEngine.intersects(parcelGeometry, pointGeometry) ||
            geometryEngine.within(pointGeometry, parcelGeometry)
        ) {
            return true;
        }

        const distanceFt = geometryEngine.distance(parcelGeometry, pointGeometry, "feet");
        return Number.isFinite(distanceFt) && distanceFt <= toleranceFt;
    } catch (err) {
        console.warn("Could not validate address point against APN parcel:", err);
        return true;
    }
};
